import { AlertTriangle, Trash2 } from 'lucide-react';

interface DeleteLinkModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isSubmitting: boolean;
}

export default function DeleteLinkModal({ open, onClose, onConfirm, isSubmitting }: DeleteLinkModalProps) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-md overflow-hidden transform transition-all scale-100">
                <div className="p-6">
                    <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center flex-shrink-0">
                            <AlertTriangle className="w-6 h-6 text-red-500" />
                        </div>
                        <div>
                            <h3 className="text-xl font-bold text-gray-900 dark:text-white">Remove Connection?</h3>
                            <p className="text-gray-600 dark:text-gray-400 text-sm mt-1">
                                Are you sure you want to remove this link? This action cannot be undone.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-gray-50 dark:bg-gray-900/50 px-6 py-4 flex justify-end gap-3 border-t border-gray-200 dark:border-gray-700">
                    <button
                        onClick={onClose}
                        disabled={isSubmitting}
                        className="px-4 py-2 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors font-medium disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isSubmitting}
                        className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium shadow-lg disabled:opacity-50"
                    >
                        {isSubmitting ? 'Removing...' : <><Trash2 className="w-4 h-4" /> Remove Link</>}
                    </button>
                </div>
            </div>
        </div>
    );
}
